import type { NavSection } from '@/components/layout/Sidebar';

/**
 * 28/09/2026 (עיצוב GoCall v2): הסדר עודכן לפי קובץ העיצוב — "הקלטות" ו"מספרים"
 * חזרו כפריטים עצמאיים, "סיכומי AI" נשאר (אחרי ביצועים).
 * תפריט בעל המרכזיה — רשימה אחת מסודרת (07/09/2026, לפי דורון), בלי קבוצות
 * מתקפלות. כל פריט = מסך אחד; מסכים שירדו מהתפריט חיים כלשוניות בתוך
 * המסך המתאים (נציגים/תיוג/מספרים → הגדרות, תא קולי → שיחות, CRM → לידים
 * ואנשי קשר, IVR/תורים/חסומים → טלפוניה). הנתיבים הישנים מפנים.
 * perm = מפתח המסך בקטלוג ההרשאות (RBAC) — פריט מוסתר למי שאין לו view.
 */
export type PermNavItem = NavSection['items'][number] & { perm: string };
export interface PermNavSection extends Omit<NavSection, 'items'> { items: PermNavItem[] }

export const ADMIN_NAV: PermNavSection[] = [
  {
    he: '',
    items: [
      { id: 'dashboard', to: '/admin', he: 'דשבורד', icon: 'chart', perm: 'dashboard' },
      { id: 'live', to: '/admin/live', he: 'ניטור חי', icon: 'headphones', perm: 'live' },
      { id: 'campaigns', to: '/admin/campaigns', he: 'קמפיינים', icon: 'target', perm: 'campaigns' },
      { id: 'leads', to: '/admin/leads', he: 'לידים ואנשי קשר', icon: 'users', perm: 'leads' },
      { id: 'calls', to: '/admin/cdr', he: 'שיחות', icon: 'phone', perm: 'cdr' },
      { id: 'recordings', to: '/admin/recordings', he: 'הקלטות', icon: 'voicemail', perm: 'recordings' },
      { id: 'performance', to: '/admin/reports', he: 'ביצועים', icon: 'trend', perm: 'reports' },
      { id: 'insights', to: '/admin/insights', he: 'סיכומי AI', icon: 'ai', perm: 'insights' },
      { id: 'telephony', to: '/admin/telephony', he: 'טלפוניה', icon: 'workflow', perm: 'telephony' },
      { id: 'numbers', to: '/admin/dids', he: 'מספרים', icon: 'hash', perm: 'telephony' },
      { id: 'billing', to: '/admin/billing', he: 'פיננסים', icon: 'doc', perm: 'billing' },
      { id: 'settings', to: '/admin/settings', he: 'הגדרות', icon: 'sliders', perm: 'settings' },
      { id: 'logs', to: '/admin/logs', he: 'יומן פעילות', icon: 'history', perm: 'logs' },
    ],
  },
];
